import { Route, Routes } from "react-router-dom";

import PublicVerificationPage from "./pages/PublicVerificationPage";

/** Sub-router for the public verification frame (marco B), mounted under `/verify/:token/*`. */
export function PublicVerificationNavigation() {
  return (
    <Routes>
      <Route index element={<PublicVerificationPage />} />
      <Route path="*" element={<PublicVerificationPage />} />
    </Routes>
  );
}
